import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputContainerModule } from '../input-container/input-container.module';
import { DropdownComponent } from './dropdown.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IconModule } from '../../icon/icon.module';
import { TranslocoModule } from '@ngneat/transloco';

@NgModule({
  declarations: [DropdownComponent],
  imports: [
    CommonModule,
    InputContainerModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    IconModule,
    TranslocoModule,
  ],
  exports: [InputContainerModule, DropdownComponent],
})
export class DropdownModule {}
